import { Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StandardizedValidators } from 'src/app/helpers/StandardizedValidators';
import { MinMaxValidator } from 'src/app/helpers/FormValidators';
import { MinMaxErrorStateMatcher } from 'src/app/helpers/CustomErrorStateMatchers';
import { FadeInOut } from 'src/app/animations/FadeInOut';
import { VerticalExpansionSlower } from 'src/app/animations/VerticalExpansion';
import { ResolutionBreakpoints } from 'src/app/modules/shared/classes/ResolutionBreakpoints';
import { CompanyValues } from 'src/app/helpers/CompanyValues';
import { eProductFilterType } from '../../classes/eProductFilterItemType';
import { eProductFilterGroupType } from '../../classes/eProductFilterGroupType';
import { ProductFilter, productFilterToQPKey, productFilterToQueryParameter } from '../../classes/ProductFilter';
import { ProductFilterGroup } from '../../classes/ProductFilterGroup';
import { ActivatedRoute } from '@angular/router';
import { RouterService } from 'src/app/services/router-service.service';
import { _32bitIntMaxValue } from 'src/app/helpers/variables/32bitIntMaxValue';

@Component({
	selector: 'app-product-search-filter-form',
	templateUrl: './product-search-filter-form.component.html',
	styleUrls: ['./product-search-filter-form.component.scss'],
	animations: [FadeInOut, VerticalExpansionSlower]
})
export class ProductSearchFilterFormComponent implements OnDestroy, OnChanges {

	@Input() filtersGroups! : ProductFilterGroup[];
	@Input() activeFilters! : ProductFilter[];
	@Input() searchInput? : string
	@Input() bLoading! : boolean;
	@Input() totalAmountOfProducts! : number;

	eProductFilterType = eProductFilterType;
	eProductFilterGroupType = eProductFilterGroupType;
	companyValues = CompanyValues;

	priceRangeFg : FormGroup;
	discountRangeFg : FormGroup;
	minMaxErrorStateMatcher = new MinMaxErrorStateMatcher();

	bCardToggle = false;

	@ViewChild("activeFiltersContainer") activeFiltersContainer! : ElementRef;

	@HostListener('window:resize')
	onResizeHandler(): void {
		if (window.innerWidth >= ResolutionBreakpoints[0])
			this.bCardToggle = true;
	}

	constructor(private routerService:RouterService,
				private activatedRoute:ActivatedRoute) {
		this.priceRangeFg = new FormGroup({
			"min": new FormControl(undefined, StandardizedValidators.positiveIntegerUpTo(_32bitIntMaxValue, true)),
			"max": new FormControl(undefined, StandardizedValidators.positiveIntegerUpTo(_32bitIntMaxValue, true))
		}, {
			validators: [MinMaxValidator]
		});
		this.discountRangeFg = new FormGroup({
			"min": new FormControl(undefined, StandardizedValidators.positiveIntegerUpTo(100, true)),
			"max": new FormControl(undefined, StandardizedValidators.positiveIntegerUpTo(100, true))
		}, {
			validators: [MinMaxValidator]
		});

		this.onResizeHandler();
	}

	ngOnDestroy() {
		this.searchInput = undefined;
		this.filtersGroups = [];
		this.activeFilters = [];
	}
	ngOnChanges(changes: SimpleChanges) {
		this.priceRangeFg.reset();
		this.discountRangeFg.reset();
		if (changes["bLoading"]?.currentValue == false) {
			this.hideIfOnMobile();
		}
	}

	//#region Eventos
	onClickFilter(pf:ProductFilter) {
		const currentParams = this.activatedRoute.snapshot.queryParams;
		this.routerService.addQueryParametersToCurrentRoute(productFilterToQueryParameter(pf), currentParams);
		this.activeFiltersContainer.nativeElement.focus();
	}
	onMinMaxFilter(pf:ProductFilter, fg:FormGroup) {
		let minMaxParam = productFilterToQueryParameter(pf, fg.get("min")!.value, fg.get("max")!.value);
		const currentParams = this.activatedRoute.snapshot.queryParams;
		this.routerService.addQueryParametersToCurrentRoute(minMaxParam, currentParams);
		this.activeFiltersContainer.nativeElement.focus();
	}
	onRemoveFilter(pf:ProductFilter) {
		this.routerService.removeQueryParameterFromCurrentRoute(productFilterToQPKey(pf));
		this.activeFiltersContainer.nativeElement.focus();
	}
	clearSearchInput() {
		this.routerService.removeQueryParameterFromCurrentRoute("i");
		this.activeFiltersContainer.nativeElement.focus();
	}
	clearAllFilters() {
		this.routerService.removeAllQueryParametersFromCurrentRoute();
		this.activeFiltersContainer.nativeElement.focus();
	}
	//#endregion

	private hideIfOnMobile() {
		if (window.innerWidth < ResolutionBreakpoints[0])
			this.bCardToggle = false;
	}
}